import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "21",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M22.75 8.75H1.695q-.711 0-1.203.492T0 10.5t.492 1.258 1.203.492h21q.765 0 1.313-.492.492-.492.492-1.258 0-.765-.492-1.258-.493-.492-1.258-.492m0 8.75H1.695q-.711 0-1.203.492Q0 18.485 0 19.195t.492 1.258T1.695 21h21q.765 0 1.313-.492.492-.493.492-1.258t-.492-1.258-1.258-.492m0-17.5H1.695Q.984 0 .492.492 0 .985 0 1.695q0 .712.492 1.258.493.547 1.203.547h21q.765 0 1.313-.492.492-.492.492-1.258T24.008.492 22.75 0"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }